import React from 'react';
import Navbar from './Navbar';
import Footer from './Footer';
import './Layout.css';

/**
 * Shared layout wrapper — renders Navbar + page content + Footer.
 * Used by every route so nav/footer appear consistently.
 */
const Layout = ({ children }) => {
    return (
        <div className="layout">
            <Navbar />
            <main className="layout-main">
                {children}
            </main>
            <Footer />
        </div>
    );
};

export default Layout;
